import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { DDCStatus } from '../../RejectedX3dSecure2RequiredError';

import {
  TXTWCL_Please_contact_customer_suppor_ELL_1,
  TXTWCL_Please_do_not_close_this_brows_ELL,
  TXTWCL_Processing_your_request_takes__ELL,
  TXTWCL_We_cannot_process_your_request_ELL_1,
  TXTWCL_Your_transaction_is_now_being__ELL
} from './DDCStatusMessages.messages.json';

interface Props {
  ddcStatus?: DDCStatus;
}

const DDCStatusMessages: React.FC<Props> = ({ ddcStatus }) => (
  <>
    {ddcStatus === DDCStatus.ddcOk && (
      <div>
        <Translation tagName="p" {...TXTWCL_Your_transaction_is_now_being__ELL} />
        <Translation tagName="p" {...TXTWCL_Please_do_not_close_this_brows_ELL} />
      </div>
    )}
    {ddcStatus === DDCStatus.ddcTimeout && (
      <div>
        <Translation tagName="p" {...TXTWCL_Processing_your_request_takes__ELL} />
        <Translation tagName="p" {...TXTWCL_Please_contact_customer_suppor_ELL_1} />
      </div>
    )}
    {ddcStatus === DDCStatus.ddcError && (
      <div>
        <Translation tagName="p" {...TXTWCL_We_cannot_process_your_request_ELL_1} />
        <Translation tagName="p" {...TXTWCL_Please_contact_customer_suppor_ELL_1} />
      </div>
    )}
  </>
);

export default DDCStatusMessages;
